import React from 'react';
import AnalyticsImage from 'components/Pages/analytics-img.svg';
import {
  Grid
} from '@material-ui/core';


export default function ComingSoonPage() {
  return (
    <Grid
      container
      spacing={0}
      direction="column"
      alignItems="center"
      justifyContent="center"
      className="mt-20"
    >
      <div className="flex-grow flex-column relative scroll-y justify-center items-center">
        <img src={AnalyticsImage} alt="under reconstruction" width="258" />
      </div>
      <h2 className="font-bold py-6 text-center text-deep-gray">Coming Soon</h2>
    </Grid>
  );
}
